module.exports = __webpack_public_path__ + "static/Gameplay_IceCandy-7f4f58810a5e75f23814db773230bf26.png";